<template>
<el-table :data="tableData" style="width: 100%" @row-click="gotoDetails" :show-header="false">
    <el-table-column>
        <template slot-scope="scope">
            <div class="d-flex justify-content-start align-items-center">
                <NameInitials :name="scope.row.name" small color="#727D94"/>
                <h5 class="c-ndarkfour bold mb-0 break-name">
                    {{ (scope.row.tradingName || scope.row.name) | formatName }}
                </h5>
                <caption class="ml-3 mb-0">
                    {{ scope.row.cnpj.cnpj | formatCnpjOrCpf }}
                </caption>
                <caption class="ml-3 mb-0">
                    {{
                        scope.row.cnpj.companyType == 0
                            ? 'Financiador'
                            : scope.row.cnpj.companyType == 1
                                ? !USER_TYPE_MIXIN.isBackOffice
                                    ? 'Fornecedor'
                                    : 'Cedente'
                                : !USER_TYPE_MIXIN.isBackOffice
                                    ? 'Comprador'
                                    : 'Sacado'
                    }}
                </caption>
                <!-- <caption :class="!USER_TYPE_MIXIN.isBackOffice ? 'ml-3 mb-0 c-ndarkfour bgc-nlightone partner' : 'hide-partner'" v-for="partner in scope.row.partners" :key="partner">
                    {{ getPartners[partner] }}
                </caption> -->
            </div>
        </template>
    </el-table-column>
    <el-table-column width="200px">
        <template slot-scope="scope">
            <div class="d-flex justify-content-end align-items-center">
                <Button class="button-details" size="small" @click="gotoDetails(scope.row)" :color="getPrimaryColor">
                    Acessar
                </Button>
            </div>
        </template>
    </el-table-column>
</el-table>
</template>

<script>
import NameInitials from '@/components/icons/NameInitials'
export default {
    components: {
        NameInitials,
    },
    props: {
        tableData: {
            required: true
        }
    },
    methods: {
        gotoDetails(row) {
            this.$router.push(`/user/company/${row.cnpj.id}`)
            this.$emit('persistFilter')
        },
    }
}
</script>

<style scoped>
.partner {
    padding: 4px 8px;
    border-radius: 26px;
}

.hide-partner {
    display: none;
}
</style>
